import { Fragment } from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Stack, Separator } from '@fluentui/react';
import ReactMarkdown from 'react-markdown';
import { FrequentQuestion } from '../api/generated/data-contracts';
import { createNewGuid } from '../components/Utils';
import { useFaqs } from '../Configuration/config/components/HelpConfig/useFaqs';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
        },
    }),
);
const defaultFaqs: FrequentQuestion[] = [
    {
        question: 'Where do i find projects I am not assigned to',
        response:
            'In the top left corner of the application there is a magnifying glass. Click this and type in the name of the project or task you want to time register on.',
        order: 1,
        id: createNewGuid(),
    },
    {
        question: 'Why is all tasks and cells read only',
        response:
            'If you have submitted your timesheet all cells becomes read only. If the period is not closed you can still open your timesheet by clicking on the Open icon in the top right corner',
        order: 1,
        id: createNewGuid(),
    },
];

function HelpFAQ() {
    const classes = useStyles();
    const { data: FAQ } = useFaqs({ suspense: true });

    return (
        <div style={{ width: '1248px', margin: 'auto', height: 'calc(100vh - 100px)', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
            <br />
            <h2>Frequently Asked Questions</h2>
            <Separator styles={{ root: { width: '100%' } }} />
            <Stack verticalAlign="start" horizontalAlign="center" grow styles={{ root: { overflowY: 'auto', overflowX: 'hidden' } }}>
                {(FAQ.length ? FAQ : defaultFaqs).map(faq => {
                    return (
                        <Fragment key={faq.id}>
                            <Accordion style={{ minWidth: '1248px' }}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                    <Typography className={classes.heading}>{faq.question}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div style={{ textAlign: 'left' }}>
                                        <ReactMarkdown linkTarget="_blank">{faq.response}</ReactMarkdown>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </Fragment>
                    );
                })}
            </Stack>
        </div>
    );
}

export default HelpFAQ;
